import React from 'react';
import ReactDOM from 'react-dom';
import { IconButton, Tooltip } from 'components';
import DatePosted from 'components/DatePosted';
import { PAGE_ROUTES } from 'lib/page-routes';
import { BasicOpportunity } from 'lib/models/opportunity';

import styles from './OpportunityCardTool.module.scss';

interface OpportunityCardToolData {
  opportunityAttributes: BasicOpportunity[];
  type: string;
  touchpointIds: string[];
}

interface OpportunityCardToolConfig {
  data: OpportunityCardToolData;
  onRedirect: () => void;
}

class OpportunityCardTool {
  private data: OpportunityCardToolData;
  private config?: OpportunityCardToolConfig;
  private wrapper: HTMLElement | undefined;

  static get toolbox() {
    return {
      title: 'Opportunity Card',
    };
  }

  constructor({
    data,
    config,
  }: {
    data: OpportunityCardToolData;
    config?: OpportunityCardToolConfig;
  }) {
    this.data = data;
    this.config = config;
    this.wrapper = undefined;
  }

  render(): HTMLElement {
    this.wrapper = document.createElement('div');
    this.wrapper.className = 'ce-block';
    this.wrapper.contentEditable = 'false';
    this.renderOpportunityCards();
    return this.wrapper;
  }

  private redirectToDashboard = () => {
    if (typeof window !== 'undefined') {
      const { touchpointIds } = this.data;
      const queryParams = touchpointIds
        ? `?touchpointIds=${touchpointIds.join(',')}`
        : '';
      window.location.href = `${PAGE_ROUTES.CAREER_OPPORTUNITY}${queryParams}`;
    }
  };

  private renderOpportunityCards(): void {
    const { opportunityAttributes, type } = this.data;
    ReactDOM.render(
      <Tooltip
        content={
          <Tooltip content={'Edit list'} color="dark" position="top">
            <IconButton
              onClick={this.config?.onRedirect}
              className={styles.tooltipIcon}
              iconName="icon_pencil"
              size="xsmallplus"
            />
          </Tooltip>
        }
        containerClassName={styles['container-wrapper']}
        className={styles.tooltip}
        position="left"
        yAlign="top"
      >
        <div>
          {type && <p className={styles.type}>💼 {type}</p>}
          {opportunityAttributes.map((attributes, index) => {
            const { public_url, title, created_at, basic_creatable_for } =
              attributes;

            return (
              <div key={index}>
                <a href={public_url} target="_blank" rel="noreferrer">
                  <section className={styles.container}>
                    <img
                      src={basic_creatable_for.icon_url}
                      className={styles.image}
                    />
                    <div className={styles.content}>
                      <div className={styles.header}>
                        <div className={styles.left}>
                          <div className={styles.tags}></div>
                          <h3 className={styles.title}>{title}</h3>
                        </div>
                      </div>
                      <div className={styles['posted-by-container']}>
                        <p className={styles['posted-by']}>
                          {basic_creatable_for.name}
                        </p>
                        <>
                          <div className={styles.dot}>•</div>
                          <DatePosted
                            className={styles.date}
                            created_at={created_at}
                          />
                        </>
                      </div>
                    </div>
                  </section>
                </a>
                {index < opportunityAttributes.length - 1 && (
                  <div className={styles.divider}></div>
                )}
              </div>
            );
          })}
        </div>
      </Tooltip>,

      this.wrapper as HTMLElement
    );
  }

  save(): OpportunityCardToolData {
    return this.data;
  }
}

export default OpportunityCardTool;
